import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { HeroIconName, HTMLParser, SvgIcon } from '@gik/ui';
import { useCalendarAnnouncementTypes } from '@gik/api/calendar/calendarAnnouncementType';
import { nl2br } from '@gik/core/utils/string';
import DateTimeDisplay from '../DateTimeDisplay/DateTimeDisplay';

export interface ICalendarAnnouncementViewProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description: string;
  typeId: number;
  selected?: boolean;
  horizontal?: boolean;
  startsAt: string;
  endsAt: string;
  allDay: boolean;
}

export function CalendarAnnouncementView({
  typeId,
  title,
  description,
  selected,
  horizontal,
  className,
  startsAt,
  endsAt,
  allDay,
}: ICalendarAnnouncementViewProps) {
  const bem = bemBlock('calendar-announcement-view');

  const { data: announcementTypes } = useCalendarAnnouncementTypes();
  const announcementType = announcementTypes.find(item => item.id === typeId);

  return (
    <div
      className={bem(
        null,
        [{ horizontal }, { vertical: !horizontal }, { selected }, { [announcementType.slug]: announcementType.slug }],
        className
      )}
    >
      <SvgIcon className={bem('icon')} name={announcementType.acf.icon as HeroIconName} />
      <span className={bem('title')}>
        <HTMLParser rawHtml={title} />
      </span>
      <DateTimeDisplay timeSeparator="to" hideDate startsAt={startsAt} endsAt={endsAt} allDay={allDay} />
      <p className={bem('description')}>
        <HTMLParser rawHtml={nl2br(description)} />
      </p>
    </div>
  );
}
